import { type FunctionalComponent, h } from '@stencil/core';
import type { SearchApiDocumentMySE } from '../../../../../api/SearchApi';
import type {ITabViewExtended} from '../types/subcomponents-types.type';

export const TabularView: FunctionalComponent<ITabViewExtended> = (props) => {
    const {
      tabularView,
      query,
      labelProvider,
      aggregatedResults,
      tableConfiguration,
      reflectedState,
      perPage,
      currentPage,
      queryResult,
      paginationChanged,
      disableFiltersOnLoading,
      isDashboardView
    } = props;

    return (
      tabularView && !isDashboardView ?
        <div class="tabular-view">
          <uiaas-search-table
            labelProvider={(e, f) => labelProvider(e, f)}
            documents={aggregatedResults as SearchApiDocumentMySE[]}
            table-configuration={tableConfiguration}
            query={query}
            reflectedState={reflectedState}
          />
          <uiaas-tabs-pagination
            perPage={perPage}
            currentPage={currentPage}
            queryResult={queryResult}
            paginationChanged={paginationChanged.bind(
              props.context
            )}
            query={query}
            aggregatedResults={aggregatedResults}
            labelProvider={(e, f) => labelProvider(e, f)}
            reflectedState={reflectedState}
            disableFiltersOnLoading={
              disableFiltersOnLoading
            }
            hideQuery={tabularView}
          />
        </div> : ''
    );
};
